import { useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { BaseDialog, LoadingFeedback } from 'components'

import RegulationVersionForm from '../RegulationVersionForm'

import helpers from 'helpers'

import { useSnackbar } from 'hooks'

import * as service from 'service'
import constants from 'constants/index'

const VersionModal = ({
  open,
  setOpen = () => {},
  type = constants.regulations.FORM_TYPES.EDIT,
  regulationId,
  regulationVersion = {},
  refresh = () => {},
}) => {
  const [loading, setLoading] = useState(false)

  const versionRef = useRef()
  const snackbar = useSnackbar()

  const isShow = type === constants.regulations.FORM_TYPES.SHOW

  const handleCreate = async () => {
    const versionData = await versionRef.current.submit()

    if (!versionData) return

    setLoading(true)

    try {
      await service.backoffice.regulationVersions.create({
        regulationId,
        ...versionData,
        startsAt: versionData.startsAt?.toISOString(),
        endsAt: versionData.endsAt?.toISOString() || null,
      })

      snackbar.open({
        message: 'Versão criada com sucesso!',
        variant: 'success',
      })

      refresh()
      setOpen(false)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(
            error?.response?.data?.error,
            false,
          ) || 'Falha ao criar versão!',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title={isShow ? 'Visualizar versão' : 'Criar nova versão'}
      closeButtonText={isShow ? 'fechar' : 'cancelar'}
      actionButtonText={isShow ? '' : 'Criar'}
      actionButton={isShow ? () => {} : handleCreate}
      disabledSubmit={loading}
    >
      <LoadingFeedback open={loading} />
      <RegulationVersionForm
        ref={versionRef}
        type={type}
        regulationVersion={regulationVersion}
      />
    </BaseDialog>
  )
}

VersionModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  type: PropTypes.oneOf(Object.values(constants.regulations.FORM_TYPES)),
  regulationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  regulationVersion: PropTypes.object,
  refresh: PropTypes.func,
}

export default VersionModal
